<template>
  <div>
    <v-toolbar flat color="white" class="hidden-sm-and-down">
      <v-toolbar-title>Varyant Yönetimi</v-toolbar-title>
      <v-divider class="mx-3" inset vertical></v-divider>
      
      <v-select
        v-model="selectedTenantId"
        :items="tenantOptions"
        item-text="tenantName"
        item-value="tenantId"
        label="Tenant Seç"
        @change="onTenantChange"
        style="min-width: 150px; margin-right: 10px; margin-top: 20px;"
      ></v-select>
      <v-divider class="mx-2" inset vertical></v-divider>
      
      <v-text-field 
        v-model="search" 
        append-icon="search" 
        label="Ara" 
        single-line 
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        dark 
        @click="showAddDialog" 
        class="mb-2"
        :disabled="!selectedTenantId"
      >
        <v-icon left>add</v-icon>
        Yeni Varyant Ekle
      </v-btn>
    </v-toolbar>

    <div class="hidden-md-and-up mobile-toolbar">
      <v-card flat>
        <v-card-title class="pb-2">
          <span class="headline">Varyant Yönetimi</span>
          <v-spacer></v-spacer>
          <v-btn 
            icon 
            color="primary" 
            @click="showAddDialog"
            :disabled="!selectedTenantId"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pt-0">
          <v-select
            v-model="selectedTenantId"
            :items="tenantOptions"
            item-text="tenantName"
            item-value="tenantId"
            label="Tenant Seç"
            @change="onTenantChange"
            outlined
            dense
            class="mb-2"
          ></v-select>
          
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            label="Ara" 
            outlined
            dense
            hide-details
            class="mb-2"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </div>

    <v-alert
      v-if="!selectedTenantId"
      type="warning"
      class="ma-4"
      prominent
    >
      <h3>Tenant Seçimi Gerekli</h3>
      <p>Varyant işlemlerini gerçekleştirmek için lütfen yukarıdan bir Tenant seçiniz.</p>
    </v-alert>

    <div v-if="selectedTenantId">
      <v-card class="elevation-2 variant-tree-container">
        <v-card-text class="pa-0">
          <v-treeview
            v-if="variantTree.length > 0"
            :items="variantTree"
            :search="search"
            item-key="id"
            item-text="name"
            item-children="children"
            hoverable
            open-on-click
            class="enhanced-tree"
          >
            <template v-slot:prepend="{ item, open }">
              <span v-if="item.isGroup" class="group-prepend-hidden"></span>
              <div v-else class="variant-thumb-container" :class="{ 'major-variant': item.isMajor }">
                <img 
                  v-if="item.imageUrl" 
                  :src="item.imageUrl" 
                  class="variant-thumb"
                  @error="handleImageError"
                >
                <span v-else class="variant-dot" :class="{ 'major-dot': item.isMajor }"></span>
              </div>
            </template>

            <template v-slot:label="{ item, open }">
              <div v-if="item.isGroup" class="group-row">
                <v-icon 
                  class="chevron-icon" 
                  :class="{ 'chevron-open': open }"
                >
                  chevron_right
                </v-icon>
                <div class="group-content">
                  <h3 class="group-title">{{ item.name }}</h3>
                  <div class="group-badges">
                    <span class="badge badge-key">
                      <v-icon x-small class="badge-icon">vpn_key</v-icon>
                      {{ item.groupKey }}
                    </span>
                    <span class="badge badge-count">
                      {{ item.children ? item.children.length : 0 }} varyant
                    </span>
                  </div>
                </div>
                <div class="group-actions">
                  <button 
                    class="action-btn-round action-add"
                    @click.stop="showAddDialogWithGroupKey(item.groupKey)"
                    title="Bu Gruba Varyant Ekle"
                  >
                    <v-icon small>add_circle</v-icon>
                  </button>
                  <button 
                    class="action-btn-round action-delete"
                    @click.stop="deleteGroup(item)"
                    title="Grubu Sil"
                  >
                    <v-icon small>delete</v-icon>
                  </button>
                </div>
              </div>

              <div v-else class="variant-item-container" :class="{ 'major-variant-row': item.isMajor }">
                <div class="variant-content">
                  <p class="variant-name">{{ item.name }}</p>
                  <div class="variant-badges">
                    <span 
                      class="badge" 
                      :class="item.isMajor ? 'badge-major' : 'badge-minor'"
                    >
                      {{ item.isMajor ? 'Ana Varyant' : 'Alt Varyant' }}
                    </span>
                    <span class="badge badge-id">
                      <v-icon x-small class="badge-icon">inventory_2</v-icon>
                      ID: {{ item.productId }}
                    </span>
                    <span v-if="item.productName" class="badge badge-product">
                      <v-icon x-small class="badge-icon">sell</v-icon>
                      {{ item.productName }}
                    </span>
                  </div>
                </div>
                <div class="variant-actions">
                  <button 
                    v-if="!item.isMajor"
                    class="action-btn-round action-star"
                    @click.stop="switchMajorVariant(item)"
                    title="Ana Varyant Yap"
                  >
                    <v-icon small>star</v-icon>
                  </button>
                  <button 
                    class="action-btn-round action-edit"
                    @click.stop="editVariant(item)"
                    title="Düzenle"
                  >
                    <v-icon small>edit</v-icon>
                  </button>
                  <button 
                    v-if="!item.isMajor"
                    class="action-btn-round action-delete"
                    @click.stop="deleteVariant(item)"
                    title="Sil"
                  >
                    <v-icon small>delete</v-icon>
                  </button>
                </div>
              </div>
            </template>
          </v-treeview>
          
          <div v-else class="text-center pa-8">
            <div v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
                size="50"
              ></v-progress-circular>
              <p class="mt-4 grey--text">Yükleniyor...</p>
            </div>
            <div v-else>
              <v-icon size="64" color="grey lighten-1">account_tree</v-icon>
              <p class="mt-4 grey--text text--darken-1">Varyant bulunamadı.</p>
              <v-btn color="primary" outlined small @click="showAddDialog" class="mt-2">
                <v-icon left>add</v-icon>
                İlk Varyantı Ekle
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="520px" persistent content-class="variant-dialog">
      <v-card class="variant-modal">
        <div class="modal-header">
          <h2 class="modal-title">{{ isEditing ? 'Varyant Düzenle' : 'Yeni Varyant' }}</h2>
        </div>
        
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Ürün Seç *</label>
            <v-autocomplete
              v-model="editedItem.productId"
              :items="activeProducts"
              :loading="productsLoading"
              :search-input.sync="productSearch"
              item-text="displayName"
              item-value="id"
              placeholder="Ürün adı veya SKU ile arayın..."
              :disabled="isEditing"
              clearable
              no-data-text="Ürün bulunamadı"
              solo
              flat
              hide-details
              :class="['custom-input', { 'disabled-input': isEditing }]"
              :menu-props="{ contentClass: 'dropdown-menu-fixed', maxWidth: 472, nudgeBottom: 8 }"
            >
              <template v-slot:item="{ item }">
                <v-list-tile-avatar>
                  <img 
                    v-if="item.imageUrl" 
                    :src="item.imageUrl" 
                    class="product-thumb"
                    @error="handleImageError"
                  >
                  <v-icon v-else color="grey lighten-1">image</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    SKU: {{ item.sku }} | ID: {{ item.id }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
              <template v-slot:selection="{ item }">
                <img 
                  v-if="item.imageUrl" 
                  :src="item.imageUrl" 
                  class="product-thumb-small mr-2"
                  @error="handleImageError"
                >
                <span class="selection-text">{{ item.name }} ({{ item.sku }})</span>
              </template>
            </v-autocomplete>
            <p class="form-hint">Aktif ürünler arasından seçim yapın</p>
          </div>

          <div class="form-group">
            <label class="form-label">Varyant Grup Başlığı *</label>
            <v-combobox
              v-model="editedItem.groupKey"
              :items="groupKeys"
              solo
              flat
              hide-details
              class="custom-input"
              :menu-props="{ contentClass: 'dropdown-menu-fixed', maxWidth: '100%', minWidth: '100%' }"
            ></v-combobox>
            <p class="form-hint">Mevcut bir grup seçin veya yeni grup adı yazın</p>
          </div>

          <div class="form-group">
            <label class="form-label">Varyant Adı *</label>
            <v-text-field
              v-model="editedItem.variantName"
              solo
              flat
              hide-details
              class="custom-input"
            ></v-text-field>
          </div>

          <div class="form-group switch-group">
            <label class="switch-container">
              <div class="switch-toggle" :class="{ active: editedItem.isMajor }" @click="editedItem.isMajor = !editedItem.isMajor">
                <div class="switch-dot"></div>
              </div>
              <div class="switch-content">
                <p class="switch-label">Ana Varyant (Major)</p>
                <p class="switch-hint">{{ editedItem.isMajor ? 'Bu varyant grubun ana varyantı olacak' : 'Bu varyant alt varyant olacak' }}</p>
              </div>
            </label>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-cancel" @click="closeDialog">İPTAL</button>
          <button 
            type="button" 
            class="btn-save" 
            @click="saveVariant"
            :disabled="!isFormValid || saving"
          >
            <span v-if="saving">Kaydediliyor...</span>
            <span v-else>KAYDET</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Varyantı Sil</v-card-title>
        <v-card-text>
          <strong>{{ variantToDelete ? variantToDelete.variantName : '' }}</strong> varyantını silmek istediğinizden emin misiniz?
          <br><br>
          <v-alert type="warning" value="true">
            Bu işlem geri alınamaz!
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="deleteDialog = false">İptal</v-btn>
          <v-btn 
            color="red darken-1" 
            flat 
            @click="confirmDelete"
            :loading="deleting"
          >
            Sil
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteGroupDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline red--text">
          <v-icon color="red" class="mr-2">warning</v-icon>
          Varyant Grubunu Sil
        </v-card-title>
        <v-card-text>
          <strong>{{ groupToDelete ? groupToDelete.groupKey : '' }}</strong> grubunu ve içindeki 
          <strong>{{ groupToDelete && groupToDelete.children ? groupToDelete.children.length : 0 }} varyantı</strong> 
          silmek istediğinizden emin misiniz?
          <br><br>
          <v-alert type="error" value="true">
            <strong>DİKKAT!</strong> Bu işlem gruptaki TÜM varyantları silecektir ve geri alınamaz!
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="deleteGroupDialog = false">İptal</v-btn>
          <v-btn 
            color="red darken-1" 
            flat 
            @click="confirmDeleteGroup"
            :loading="deletingGroup"
          >
            Grubu Sil
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="switchMajorDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline amber--text text--darken-2">
          <v-icon color="amber darken-2" class="mr-2">star</v-icon>
          Ana Varyant Değiştir
        </v-card-title>
        <v-card-text>
          <strong>{{ variantToSwitch ? variantToSwitch.variantName : '' }}</strong> varyantını 
          <strong>Ana Varyant</strong> yapmak istediğinizden emin misiniz?
          <br><br>
          <v-alert type="info" value="true">
            Mevcut ana varyant otomatik olarak alt varyant yapılacaktır.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="switchMajorDialog = false">İptal</v-btn>
          <v-btn 
            color="amber darken-2" 
            flat 
            @click="confirmSwitchMajor"
            :loading="switchingMajor"
          >
            Ana Varyant Yap
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
      <v-btn dark flat @click="snackbar = false">Kapat</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: function() {
    return {
      selectedTenantId: null,
      tenantOptions: [
        { tenantId: 1, tenantName: "Altinda Firsat" },
        { tenantId: 2, tenantName: "EAltin" }
      ],
      search: '',
      productSearch: '',
      loading: false,
      productsLoading: false,
      saving: false,
      deleting: false,
      deletingGroup: false,
      dialog: false,
      deleteDialog: false,
      deleteGroupDialog: false,
      isEditing: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      variantToDelete: null,
      groupToDelete: null,
      variantToSwitch: null,
      switchMajorDialog: false,
      switchingMajor: false,
      productsList: [],
      cdnUrl: '',
      editedItem: {
        productId: null,
        groupKey: '',
        variantName: '',
        isMajor: false
      },
      defaultItem: {
        productId: null,
        groupKey: '',
        variantName: '',
        isMajor: false
      }
    };
  },

  computed: {
    ...mapState("variants", ["all", "groupKeys"]),

    activeProducts: function() {
      var self = this;
      var existingVariantProductIds = this.all.map(function(v) { return v.productId; });
      
      return this.productsList
        .filter(function(p) { 
          var isActive = p.state === true || p.state === 1;
          var isAlreadyVariant = existingVariantProductIds.indexOf(p.id) !== -1;
          var isCurrentEditing = self.isEditing && self.editedItem.productId === p.id;
          return isActive && (!isAlreadyVariant || isCurrentEditing);
        })
        .map(function(p) {
          var imageUrl = null;
          if (p.images && self.cdnUrl) {
            try {
              var images = JSON.parse(p.images);
              if (images && images.length > 0) {
                var firstImage = images[0];
                if (firstImage.indexOf('http://') === 0 || firstImage.indexOf('https://') === 0 || firstImage.indexOf('//') === 0) {
                  imageUrl = firstImage;
                } else {
                  imageUrl = 'https://' + self.cdnUrl + '/' + firstImage;
                }
              }
            } catch (e) {}
          }
          return {
            id: p.id,
            name: p.name,
            sku: p.sku,
            displayName: p.sku + ' - ' + p.name,
            imageUrl: imageUrl
          };
        });
    },

    variantTree: function() {
      var self = this;
      var grouped = {};
      
      this.all.forEach(function(variant) {
        if (!grouped[variant.groupKey]) {
          grouped[variant.groupKey] = [];
        }
        
        var product = self.productsList.find(function(p) { return p.id === variant.productId; });
        var imageUrl = null;
        if (product && product.images && self.cdnUrl) {
          try {
            var images = JSON.parse(product.images);
            if (images && images.length > 0) {
              var firstImage = images[0];
              if (firstImage.indexOf('http://') === 0 || firstImage.indexOf('https://') === 0 || firstImage.indexOf('//') === 0) {
                imageUrl = firstImage;
              } else {
                imageUrl = 'https://' + self.cdnUrl + '/' + firstImage;
              }
            }
          } catch (e) {}
        }
        
        grouped[variant.groupKey].push({
          id: 'variant-' + variant.productId,
          productId: variant.productId,
          name: variant.variantName,
          variantName: variant.variantName,
          groupKey: variant.groupKey,
          isMajor: variant.isMajor,
          productName: product ? product.name : '',
          imageUrl: imageUrl,
          isGroup: false
        });
      });

      var tree = [];
      Object.keys(grouped).forEach(function(groupKey) {
        var children = grouped[groupKey].sort(function(a, b) {
          if (a.isMajor && !b.isMajor) return -1;
          if (!a.isMajor && b.isMajor) return 1;
          return 0;
        });
        
        tree.push({
          id: 'group-' + groupKey,
          name: groupKey,
          groupKey: groupKey,
          isGroup: true,
          children: children
        });
      });

      return tree.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    },

    isFormValid: function() {
      return this.editedItem.productId && 
             this.editedItem.groupKey && 
             this.editedItem.variantName;
    }
  },

  watch: {
    productSearch: function(val) {
      var self = this;
      if (val && val.length >= 2 && !this.productsLoading) {
        this.searchProducts(val);
      } else if (!val || val.length < 2) {
        this.loadProducts();
      }
    }
  },

  methods: {
    ...mapActions("variants", ["getAll", "getGroupKeys", "post", "put", "delete", "switchMajor"]),

    onTenantChange: function() {
      var self = this;
      if (this.selectedTenantId) {
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
        localStorage.removeItem('selectedMpId');
        this.$store.commit("variants/clear");
        this.productsList = [];
        this.initialize();
      } else {
        this.$store.commit("variants/clear");
        this.productsList = [];
      }
    },

    initialize: function() {
      var self = this;
      if (!this.selectedTenantId) {
        return;
      }
      
      this.loading = true;
      
      Promise.all([
        this.getAll(),
        this.getGroupKeys(),
        this.loadProducts(),
        this.loadConfig()
      ])
      .catch(function() {
        self.showError('Veriler yüklenirken hata oluştu');
      })
      .finally(function() {
        self.loading = false;
      });
    },

    loadConfig: function() {
      var self = this;
      return this.$store.dispatch('appSettings/getConfig')
        .then(function(config) {
          self.cdnUrl = config.cdnUrl || '';
        })
        .catch(function() {});
    },

    loadProducts: function() {
      var self = this;
      return this.$store.dispatch('products/searchProduct', { search: '', state: true, categoryId: -1 })
        .then(function(products) {
          self.productsList = products || [];
        });
    },

    searchProducts: function(query) {
      var self = this;
      this.productsLoading = true;
      this.$store.dispatch('products/searchProduct', { search: query, state: true, categoryId: -1 })
        .then(function(products) {
          self.productsList = products || [];
        })
        .finally(function() {
          self.productsLoading = false;
        });
    },

    showAddDialog: function() {
      if (!this.selectedTenantId) {
        this.showError('Lütfen önce bir Tenant seçiniz!');
        return;
      }
      
      this.isEditing = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },

    showAddDialogWithGroupKey: function(groupKey) {
      if (!this.selectedTenantId) {
        this.showError('Lütfen önce bir Tenant seçiniz!');
        return;
      }
      
      this.isEditing = false;
      this.editedItem = Object.assign({}, this.defaultItem, { groupKey: groupKey });
      this.dialog = true;
    },

    editVariant: function(item) {
      this.isEditing = true;
      this.editedItem = {
        productId: item.productId,
        groupKey: item.groupKey,
        variantName: item.variantName,
        isMajor: item.isMajor
      };
      this.dialog = true;
    },

    deleteVariant: function(item) {
      this.variantToDelete = item;
      this.deleteDialog = true;
    },

    confirmDelete: function() {
      var self = this;
      if (!this.variantToDelete) return;

      this.deleting = true;
      this.delete(this.variantToDelete.productId)
        .then(function(result) {
          if (result.success) {
            self.showSuccess(result.message);
            self.deleteDialog = false;
            self.variantToDelete = null;
            self.getGroupKeys();
          } else {
            self.showError(result.message);
          }
        })
        .catch(function(error) {
          var message = 'Varyant silinirken hata oluştu';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          self.showError(message);
        })
        .finally(function() {
          self.deleting = false;
        });
    },

    deleteGroup: function(item) {
      this.groupToDelete = item;
      this.deleteGroupDialog = true;
    },

    confirmDeleteGroup: function() {
      var self = this;
      if (!this.groupToDelete) return;

      this.deletingGroup = true;
      this.$store.dispatch('variants/deleteGroup', this.groupToDelete.groupKey)
        .then(function(result) {
          if (result.success) {
            self.showSuccess(result.message);
            self.deleteGroupDialog = false;
            self.groupToDelete = null;
            self.getGroupKeys();
          } else {
            self.showError(result.message);
          }
        })
        .catch(function(error) {
          var message = 'Grup silinirken hata oluştu';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          self.showError(message);
        })
        .finally(function() {
          self.deletingGroup = false;
        });
    },

    saveVariant: function() {
      var self = this;
      if (!this.isFormValid) return;

      this.saving = true;
      var action = this.isEditing ? this.put(this.editedItem) : this.post(this.editedItem);
      
      action
        .then(function(result) {
          if (result.success) {
            self.showSuccess(result.message);
            self.closeDialog();
            self.getGroupKeys();
          } else {
            self.showError(result.message);
          }
        })
        .catch(function(error) {
          var message = 'Varyant kaydedilirken hata oluştu';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          self.showError(message);
        })
        .finally(function() {
          self.saving = false;
        });
    },

    switchMajorVariant: function(item) {
      this.variantToSwitch = item;
      this.switchMajorDialog = true;
    },

    confirmSwitchMajor: function() {
      var self = this;
      if (!this.variantToSwitch) return;

      this.switchingMajor = true;
      this.switchMajor(this.variantToSwitch.productId)
        .then(function(result) {
          if (result.success) {
            self.showSuccess(result.message);
            self.switchMajorDialog = false;
            self.variantToSwitch = null;
          } else {
            self.showError(result.message);
          }
        })
        .catch(function(error) {
          var message = 'İşlem sırasında hata oluştu';
          if (error.response && error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          self.showError(message);
        })
        .finally(function() {
          self.switchingMajor = false;
        });
    },

    closeDialog: function() {
      this.dialog = false;
      this.isEditing = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    showSuccess: function(message) {
      this.snackbarText = message;
      this.snackbarColor = 'success';
      this.snackbar = true;
    },

    showError: function(message) {
      this.snackbarText = message;
      this.snackbarColor = 'error';
      this.snackbar = true;
    },

    handleImageError: function(event) {
      event.target.style.display = 'none';
    }
  },

  mounted: function() {
    var self = this;
    var savedTenantId = localStorage.getItem('selectedTenantId');
    if (savedTenantId && savedTenantId !== '0') {
      this.selectedTenantId = parseInt(savedTenantId);
      this.initialize();
    }
  },

  beforeDestroy: function() {
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
    this.$store.commit("variants/clear");
  }
};
</script>

<style scoped>
.variant-tree-container {
  margin: 16px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.enhanced-tree {
  padding: 16px;
}

.enhanced-tree >>> .v-treeview-node__root {
  padding: 0;
  margin: 0 0 12px 0;
  min-height: auto;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.enhanced-tree >>> .v-treeview-node__root:hover {
  background-color: transparent;
}

.enhanced-tree >>> .v-treeview-node__content {
  margin-left: 0;
  padding: 0;
}

.enhanced-tree >>> .v-treeview-node__prepend {
  min-width: 0;
  margin-right: 0;
}

.group-prepend-hidden {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

.enhanced-tree >>> .v-treeview-node__label {
  flex: 1;
  overflow: visible;
  width: 100%;
}

.enhanced-tree >>> .v-treeview-node__toggle {
  display: none !important;
  width: 0 !important;
}

/* ===== GRUP SATIRI (Tek bileşen) ===== */
.group-row {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
}

.group-row:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chevron-icon {
  color: #64748b;
  transition: transform 0.3s ease;
  font-size: 22px !important;
  margin-right: 12px;
  flex-shrink: 0;
}

.chevron-icon.chevron-open {
  transform: rotate(90deg);
}

.group-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.group-title {
  font-size: 17px;
  font-weight: 600;
  color: #334155;
  margin: 0;
  letter-spacing: -0.01em;
}

.group-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.group-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 16px;
}

/* ===== VARIANT PREPEND (Image/Dot) ===== */
.variant-thumb-container {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  margin-right: 16px;
}

.variant-thumb-container.major-variant {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.variant-thumb {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 6px;
}

.variant-dot {
  width: 10px;
  height: 10px;
  background: #9ca3af;
  border-radius: 50%;
}

.variant-dot.major-dot {
  background: #f59e0b;
}

/* ===== VARIANT ITEM ROW ===== */
.variant-item-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
  gap: 16px;
}

.variant-item-container:hover {
  border-color: #e2e8f0;
  background: #f1f5f9;
}

.variant-item-container.major-variant-row {
  background: #f9fafb;
  border: 1px solid #e2e8f0;
}

.variant-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.variant-name {
  font-size: 15px;
  font-weight: 600;
  color: #334155;
  margin: 0;
}

.variant-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.variant-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* ===== BADGES ===== */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 9999px;
  white-space: nowrap;
}

.badge-icon {
  font-size: 14px !important;
}

.badge-key {
  background: #f3e8ff;
  color: #7c3aed;
}

.badge-count {
  background: #e5e7eb;
  color: #64748b;
}

.badge-major {
  background: #ffedd5;
  color: #ea580c;
}

.badge-minor {
  background: #e5e7eb;
  color: #64748b;
}

.badge-id {
  background: #dbeafe;
  color: #1d4ed8;
}

.badge-product {
  background: #dcfce7;
  color: #15803d;
}

/* ===== ACTION BUTTONS (Round) ===== */
.action-btn-round {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #64748b;
}

.action-btn-round .v-icon {
  font-size: 20px !important;
  color: inherit !important;
}

.action-add:hover {
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.action-edit:hover {
  background: rgba(100, 116, 139, 0.15);
  color: #475569;
}

.action-delete:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.action-star:hover {
  background: rgba(234, 179, 8, 0.1);
  color: #eab308;
}

/* ===== CHILDREN SPACING ===== */
.enhanced-tree >>> .v-treeview-node__children {
  padding-left: 24px;
  padding-top: 8px;
}

.enhanced-tree >>> .v-treeview-node__children .v-treeview-node__root {
  margin-bottom: 8px;
}

/* ===== MOBILE RESPONSIVE ===== */
.mobile-toolbar {
  padding: 0 16px;
}

@media (max-width: 768px) {
  .group-row {
    flex-wrap: wrap;
    gap: 12px;
    padding: 14px 16px;
  }

  .group-row .group-content {
    flex: 1 1 calc(100% - 50px);
    min-width: 200px;
  }

  .group-row .group-actions {
    margin-left: auto;
  }

  .variant-item-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 14px;
  }

  .variant-actions {
    align-self: flex-end;
  }

  .variant-thumb-container {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .variant-thumb {
    width: 32px;
    height: 32px;
  }

  .badge {
    font-size: 11px;
    padding: 3px 8px;
  }

  .enhanced-tree >>> .v-treeview-node__children {
    padding-left: 12px;
  }
}

/* ===== UTILITY STYLES ===== */
.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.text-center p {
  font-size: 14px;
  color: #555;
}

.v-alert {
  border-radius: 8px;
}

.v-toolbar-title {
  font-weight: 600;
  color: #1a1a1a;
}

.product-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.product-thumb-small {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.variant-modal {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
  letter-spacing: 0.01em;
}

.form-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.custom-input {
  border: 1px solid #d1d5db !important;
  border-radius: 8px !important;
  background: #fff !important;
}

.custom-input >>> .v-input__slot {
  background: #fff !important;
  border-radius: 8px !important;
  min-height: 48px !important;
  padding: 0 14px !important;
  box-shadow: none !important;
  align-items: center !important;
}

.custom-input >>> .v-text-field__slot {
  padding: 8px 0 !important;
}

.custom-input >>> .v-text-field__slot input,
.custom-input >>> .v-select__selection,
.custom-input >>> .v-select__slot input,
.custom-input >>> .v-select__selection--comma {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
  line-height: 1.5 !important;
  padding: 2px 0 !important;
  margin: 0 !important;
}

.custom-input >>> .v-input__control {
  min-height: 48px !important;
}

.custom-input >>> .v-text-field__slot,
.custom-input >>> .v-select__slot {
  display: flex !important;
  align-items: center !important;
}

.custom-input >>> .v-text-field__slot input::placeholder {
  color: #9ca3af !important;
  font-weight: 400 !important;
}

.custom-input >>> .v-select__selections {
  padding: 0 !important;
  line-height: 1.5 !important;
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  max-width: calc(100% - 30px) !important;
}

.custom-input >>> .v-input__icon {
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-input >>> .v-icon {
  font-size: 20px !important;
}

.disabled-input {
  background: #f3f4f6 !important;
  border-color: #e5e7eb !important;
  cursor: not-allowed !important;
}

.disabled-input >>> .v-input__slot {
  background: #f3f4f6 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.disabled-input >>> .v-text-field__slot input,
.disabled-input >>> .v-select__selection,
.disabled-input >>> .selection-text {
  color: #9ca3af !important;
  font-weight: 400 !important;
  cursor: not-allowed !important;
}

.disabled-input >>> .v-input__icon {
  opacity: 0.5;
}

.disabled-input .product-thumb-small {
  opacity: 0.5;
  filter: grayscale(30%);
}

.selection-text {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px);
  display: block;
}

.custom-input >>> .v-input__slot {
  overflow: hidden !important;
}

.custom-input >>> .v-select__slot {
  overflow: hidden !important;
  max-width: 100% !important;
}

.switch-group {
  margin-top: 8px;
}

.switch-container {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}

.switch-toggle {
  width: 48px;
  height: 24px;
  background: #e5e7eb;
  border-radius: 12px;
  position: relative;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.switch-toggle.active {
  background: #f97316;
}

.switch-dot {
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.switch-toggle.active .switch-dot {
  transform: translateX(24px);
}

.switch-content {
  margin-left: 12px;
}

.switch-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin: 0;
}

.switch-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 0 0;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #0d6efd;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-cancel:hover {
  background: #eff6ff;
}

.btn-save {
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #0d6efd;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-save:hover {
  background: #0b5ed7;
}

.btn-save:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}
</style>

<style>
.dropdown-menu-fixed {
  max-width: 472px !important;
  min-width: 200px !important;
  width: 472px !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
  margin-top: 4px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.dropdown-menu-fixed .v-list {
  padding: 8px 0 !important;
  max-width: 100% !important;
}

.dropdown-menu-fixed .v-list-item,
.dropdown-menu-fixed .v-list__tile {
  padding: 8px 16px !important;
  min-height: 56px !important;
  max-width: 100% !important;
}

.dropdown-menu-fixed .v-list-item__content,
.dropdown-menu-fixed .v-list__tile__content {
  max-width: calc(100% - 50px) !important;
  overflow: hidden !important;
}

.dropdown-menu-fixed .v-list-item__title,
.dropdown-menu-fixed .v-list__tile__title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  display: block !important;
}

.dropdown-menu-fixed .v-list-item__subtitle,
.dropdown-menu-fixed .v-list__tile__sub-title {
  font-size: 12px !important;
  color: #64748b !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.dropdown-menu-fixed .v-list-item:hover,
.dropdown-menu-fixed .v-list__tile:hover {
  background: #f1f5f9 !important;
}

.dropdown-menu-fixed .v-list-item--active,
.dropdown-menu-fixed .v-list__tile--active {
  background: #eff6ff !important;
}

.dropdown-menu-fixed .v-list-item--active .v-list-item__title,
.dropdown-menu-fixed .v-list__tile--active .v-list__tile__title {
  color: #2563eb !important;
}

.dropdown-menu-fixed .v-list-item__avatar,
.dropdown-menu-fixed .v-list__tile__avatar {
  min-width: 40px !important;
  margin-right: 12px !important;
}
</style>
